import { Outlet, Link } from "react-router-dom"
import { useAuthStore } from "@/store/authStore"
import { Button } from "@/components/ui/button"
import { Lock } from "lucide-react"
import { PLAN_FEATURES, PRO_PRICE_LABEL } from "@/lib/planFeatures"
import { hasProPlan } from "@/lib/planNames"

export function ProRoute() {
  const user = useAuthStore(s => s.user)
  if (hasProPlan(user)) return <Outlet />

  return (
    <div className="px-4 md:px-8 py-10 md:py-16">
      <div className="max-w-xl mx-auto rounded-lg border bg-card p-6 md:p-8">
        <span className="inline-flex h-10 w-10 items-center justify-center rounded-md bg-positive-50 text-positive-800 dark:bg-positive-950 dark:text-positive-200">
          <Lock className="h-5 w-5" />
        </span>
        <h1 className="mt-5 text-[22px] font-semibold tracking-[-0.02em]">Este recurso faz parte do plano Pro</h1>
        <p className="mt-2 text-muted-foreground leading-relaxed">
          Assine o Pro por {PRO_PRICE_LABEL} por mês para usar esta página e todo o restante do FinControl.
        </p>
        <ul className="mt-5 space-y-2 text-[14px]">
          {PLAN_FEATURES.pro.slice(1, 5).map(f => (
            <li key={f} className="flex gap-2.5"><span className="text-positive-700 dark:text-positive-400" aria-hidden="true">✓</span>{f}</li>
          ))}
        </ul>
        <div className="mt-6 flex flex-wrap gap-2">
          <Button asChild><Link to="/pricing">Ver planos</Link></Button>
          <Button asChild variant="outline"><Link to="/dashboard">Voltar ao painel</Link></Button>
        </div>
      </div>
    </div>
  )
}
